var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceAndTechnologyDebug(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3880.000000, -1308.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device-and-technology/Debug",
    transform: "translate(3880.000000, 1308.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5122774,5.825 L26.431395,9.867 C25.9497437,10.343 25.303157,11.058 24.5715731,11.089 C24.3034269,11.1 24.04034,11.009 23.8086212,10.874 C23.3148273,10.584 22.895912,10.139 22.4931867,9.741 L22.1248651,9.376 L21.1443605,8.408 C20.7416352,8.01 20.29034,7.596 19.9979088,7.108 C19.861306,6.88 19.7692256,6.618 19.7803562,6.354 C19.8117242,5.632 20.5352132,4.992 21.0158527,4.516 L25.1068538,0.482 C24.2093227,0.176 23.2490556,0 22.2452779,0 C17.4105505,0 13.4905559,3.874 13.4905559,8.652 C13.4905559,10.004 13.8133432,11.279 14.3729088,12.419 L2.68173233,23.973 C0.439422558,26.189 0.439422558,29.784 2.68173233,32 L18.4335537,16.432 C19.5881004,16.985 20.878238,17.304 22.2452779,17.304 C27.0800054,17.304 31,13.43 31,8.652 C31,7.66 30.8239342,6.712 30.5122774,5.825",
    id: 125
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceAndTechnologyDebug);
export default __webpack_public_path__ + "static/media/device-and-technology-debug.e32a7efb.svg";
export { ForwardRef as ReactComponent };